export const environment = {
  production: true,
  tenant: "camco",
  appName: "Camco",
  // api_url: "http://localhost:8787/",
  api_url: "https://api.camconevada.com/",
  admin_api_key: "camcoadminauthroutekmj",
  token_label: "__@camco_authadmin",
};
